import { render, staticRenderFns } from "./FirstStepIronPalace.vue?vue&type=template&id=ef0b8a7a&scoped=true&"
import script from "./FirstStepIronPalace.vue?vue&type=script&lang=js&"
export * from "./FirstStepIronPalace.vue?vue&type=script&lang=js&"
import style0 from "./FirstStepIronPalace.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FirstStepIronPalace.vue?vue&type=style&index=1&id=ef0b8a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0b8a7a",
  null
  
)

export default component.exports